import Layout from './layout.svelte'
import Navigation from './navigation.svelte'
import Content from './content.svelte'
import Titles from './titles.svelte'

const Page = {
  Layout,
  Navigation,
  Content,
  Titles,
}

export default Page